import(/* webpackMode: "eager" */ "/app/landing/src/app/docs/page.tsx");
